<template lang="pug">
section#company-view.pt0
  second-menu(:tabs="tabs", :synctab.sync="selectedTab", :is-sticky='true')
  #company-view-content(flex="row justify-start wrap")
    .grid(v-for="company in showCompany(companies)")
      item(
        ':link'="company | companyDetailUrl category.id | slug"
        ':title'="company.name.en"
        ':full-text'="true",
        ':mobile-list'="true",
        ':image'="company.thumbnail_image | resource"
        )
</template>

<script>
import axios from 'axios'
import Item from './../item.vue'
import SecondMenu from '../second-menu.vue'

const categories = [
  {
    id: 'all',
    worddict: 'JOB_ALL'
  },
  {
    id: 'Technology',
    worddict: 'JOB_TECHNOLOGY'
  },
  {
    id: 'E&S',
    worddict: 'JOB_EL'
  },
  {
    id: 'N-S Media',
    worddict: 'JOB_NS_MEDIA'
  },
  {
    id: 'F&B',
    worddict: 'JOB_FB'
  }
]

export default {
  data () {
    return {
      category: {},
      selectedTab: 'all',
      companies: [],
      tabs: _.map(categories, (val) => ({title: window.wordDict[val.worddict], id: val.id})),
    }
  },
  created () {
    axios.get('/api/companies', {
      params: {
        hits: 1000
      }
    })
    .then((response) => {
      if (_.has(response.data, 'results')) {
        this.companies = response.data.results
      }
    })
  },
  ready () {
    let category = decodeURIComponent(this.$route.query.category || 'all')
    this.category = _.findWhere(categories, {id: category})
    this.selectedTab = category
  },
  watch: {
    selectedTab(val) {
      let cat = _.findWhere(categories, {id: val})
      this.category = cat
    },
  },
  attached () {},
  methods : {
    showCompany(companies) {
      if (this.category.id == 'all') {
        return companies
      } else {
        return companies.filter((company) => company.category == this.category.id)
      }
    },
  },
  components: {
    item: Item,
    SecondMenu
  }
}
</script>

<style lang="scss">
@import "global";
@media (max-width: $grid-float-breakpoint-max) {
  .grid {
    a.block {
      display: flex;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "global";
@media (max-width: $grid-float-breakpoint-max) {
  section {
    &:last-child {
      padding-bottom: 16px;
    }
  }
}
#company-view-content {
  padding-bottom: 80px;
  padding-top: 58px;
  @media(max-width: $grid-float-breakpoint-max) {
    padding-top: 0;
  }
}
.container:before {
  content: none;
}
.grid {
  width: 25%;
}

@media (max-width: $grid-float-breakpoint-max) {
  .grid {
    width: 100%;
    border-bottom: 1px solid $gray-lighter;
  }
  #company-view-content {
    margin-top: $responsive-mdl-selector-height + 2px;
  }
}
</style>



// WEBPACK FOOTER //
// company-list.vue?598a92ed